import React from 'react';
import { Menu } from 'lucide-react';
export function AdvertorialHeader() {
  return <header className="w-full bg-[#1a4d2e] text-white shadow-md font-sans" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between" data-id="element-2">
        <div className="flex items-center space-x-3" data-id="element-3">
          <Menu className="h-5 w-5 lg:hidden cursor-pointer opacity-80" data-id="element-4" />
          <div className="font-bold tracking-wide text-sm sm:text-base" data-id="element-5">
            Malaysian Wellness Review | Health & Lifestyle
          </div>
        </div>
        <div className="hidden sm:block text-[10px] font-bold tracking-widest bg-white/10 px-2 py-1 rounded text-white/90 uppercase" data-id="element-6">
          Advertorial
        </div>
      </div>
    </header>;
}